import {
    BACKGROUND_IMAGE_LOADED,
    BACKGROUND_SHOW_HIDE,
    BACKGROUND_MOVED,
    BACKGROUND_TRANSFORMED,
    BACKGROUND_EDIT,
    PROJECTS_CRUD_RESTORE_STATE,
    APPTOOLBAR_RESET_APP_STATE,
    BACKGROUND_SCALE,
    NEW_BACKGROUND_REQUESTED, SHOW_BACKGROUND_MULTIBED_WARNING, SHOW_BACKGROUND_MOVED_TRANSFORMED,
} from "../lib/types";
import { createSelector } from "reselect";
import store from "../store";
import { Background } from "../lib/project-build";

const initialState = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
    rotation: 0,
    setCount: 0,
    bgImg: null,
    bgShow: false,
    appliedScale: 0,
    newBackgroundRequestedByClick: false,
    showBackgroundMultiBedWarning: false,
    backgroundMovedTransformed: false,
};

export let BackgroundReducer = ( state = initialState, action ) => {
    /* discriminate the action type */
    switch (action.type) {

        case BACKGROUND_IMAGE_LOADED:
            return {
                ...state,
                bgImg: action.payload,
                bgShow: true,
                setCount: state.setCount + 1,
            };

        case BACKGROUND_SHOW_HIDE:
            return {
                ...state,
                bgShow: action.payload,
            };

        case BACKGROUND_MOVED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y,
                backgroundMovedTransformed: true,
            };

        case BACKGROUND_TRANSFORMED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y,
                scaleX: action.payload.scaleX,
                scaleY: action.payload.scaleY,
                rotation: action.payload.rotation,
                backgroundMovedTransformed: true,
            };

        case BACKGROUND_EDIT:
            return {
                ...state,
                bgEdit: action.payload,
            };

        case BACKGROUND_SCALE:
            return {
                ...state,
                appliedScale: action.payload,
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.background;
            /* restore image base64 */
            if (rState.specs) {
                let image = new Image();
                image.src = rState.specs.data;
                image.height = rState.specs.height;
                image.width = rState.specs.width;
                rState.bgImg = image;
                rState.bgShow = true;
                rState.setCount = state.setCount + 1;
                rState.newBackgroundRequestedByClick = false;
                rState.backgroundMovedTransformed = false;
                window.myImage = rState.bgImg;
            }
            return {
                ...rState,
                bgImg: rState.bgImg,
            };

        case NEW_BACKGROUND_REQUESTED:
            return {
                ...state,
                newBackgroundRequestedByClick: action.payload.newBackgroundRequestedByClick,
            };

        case SHOW_BACKGROUND_MULTIBED_WARNING:
            return {
                ...state,
                showBackgroundMultiBedWarning: action.payload.showBackgroundMultiBedWarning,
            };

        case SHOW_BACKGROUND_MOVED_TRANSFORMED:
            return {
                ...state,
                backgroundMovedTransformed: action.payload.backgroundMovedTransformed,
            };

        default:
            return state;
    }
};


const getBackgroundImage = state => state.background.bgImg;
const getBackgroundShow = state => state.background.bgShow;
const BackgroundSelectors = {
    getBackgroundImageBase64: () => {
        try {
            const getHBackgroundImg = createSelector(
                [getBackgroundImage],
                ( img ) => {
                    if (img && img.currentSrc)
                        return img.currentSrc;
                    return "";
                });
            return getHBackgroundImg(store.getState());
        } catch (error) {
            console.error(`BackgroundSelectors.getBackgroundImageString() :: ${error.message}`);
        }
    },
    getBackgroundObj: () => {
        try {
            const getHBackgroundImg = createSelector(
                [getBackgroundImage, getBackgroundShow],
                ( img, bgShow ) => {
                    let bg = undefined;
                    let stage = window.konvaStage;
                    let background = stage.find("#background")[0];
                    if (background && bgShow) {
                        // extract the chamber bed properties
                        let bgRotation = background.rotation();
                        let bgX = background.x();
                        let bgY = background.y();
                        let bgHeight = background.height();
                        let bgWidth = background.width();
                        let bgScaleX = background.scaleX();
                        let bgScaleY = background.scaleY();
                        // extracting background data
                        let bgData = backgroundToPNG(background);

                        // instance the background serialization object
                        bg = new Background(
                            bgX,
                            bgY,
                            bgScaleX,
                            bgScaleY,
                            bgRotation,
                            bgWidth,
                            bgHeight,
                            bgData,
                        );
                    }
                    return bg;
                });
            return getHBackgroundImg(store.getState());
        } catch (error) {
            console.error(`BackgroundSelectors.getBackgroundImageString() :: ${error.message}`);
        }
    },

};

const backgroundToPNG = ( background ) => {
    let image = background.getImage();
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext("2d").drawImage(image, 0, 0);
    /* extract the base64 enconded bytes(strip the 'data:image/png;base64,') */
    return canvas.toDataURL("image/png").split(",")[1];
};

export default BackgroundSelectors;



// WEBPACK FOOTER //
// ./src/reducers/background-reducer.js